import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import { AllHtmlEntities as Entities } from 'html-entities';
import { Rate } from 'antd';
import cx from 'classnames';
import moment from 'moment';
import StartIcon from 'material-design-icons/action/svg/production/ic_star_rate_18px.svg';

import c from './ReviewEntry.less';

const entities = new Entities();
const roundToHalf = (num) => Math.round(num * 2) / 2;

const reviewStates = {
  AWAITING_APPROVAL: <span className={cx(c.tag, c.pending)} color="orange">Pending approval</span>,
  REJECTED: <span className={cx(c.tag, c.rejected)} color="red">Rejected</span>,
};

function ReviewEntry({
  username, rate, message, state, title, date, country,
}) {
  return (
    <div className={c.reviewBlock}>
      <div className={cx(c.header, { [c.withDate]: date.length > 0 })}>
        <div className={c.leftBlock}>
          <span className={c.author}>
            {
              (country.length > 0 && country !== '--') ? (
                <span className={cx(c['flag-icon'], c[`flag-icon-${country.toLowerCase()}`], c.flag)} />
              ) : null
            }
            {username}
          </span>
          {date.length > 0 ? <span className={c.date}>{moment.utc(date).fromNow()}</span> : null}
        </div>
        <div className={c.rightBlock}>
          {
            reviewStates[state] && (
              <div className={c.status}>{reviewStates[state]}</div>
            )
          }
          <Rate character={<StartIcon />} className={c.rate} disabled allowHalf value={roundToHalf(rate)} />
        </div>
      </div>
      {title.length > 0 ? <h4 className={c.title}>{title}</h4> : null}
      <div>{ReactHtmlParser(entities.decode(message))}</div>
    </div>
  );
}

ReviewEntry.propTypes = {
  username: PropTypes.string.isRequired,
  rate: PropTypes.number.isRequired,
  message: PropTypes.string.isRequired,
  state: PropTypes.string.isRequired,
  title: PropTypes.string,
  date: PropTypes.string,
  country: PropTypes.string,
};

ReviewEntry.defaultProps = {
  title: '',
  date: '',
  country: '',
};

export default ReviewEntry;
